export default __webpack_public_path__ + "static/media/IX.59030e90.png";